export const LESSON_SPARK_USER_VIEW_LOAD_REQUEST = 'LESSON_SPARK_USER_VIEW_LOAD_REQUEST';
export const LESSON_SPARK_USER_VIEW_LOAD_SUCCESS = 'LESSON_SPARK_USER_VIEW_LOAD_SUCCESS';
export const LESSON_SPARK_USER_VIEW_LOAD_FAILURE = 'LESSON_SPARK_USER_VIEW_LOAD_FAILURE';
